const filterWayEnum = {
  RANKING: {
    code: 0,
    name: "RANKING",
    desc: "排名",
    kind: "filterWay"
  },
  SCORE: {
    code: 1,
    name: "SCORE",
    desc: "分数",
    kind: "filterWay"
  },
  GOOD_ANSWER: {
    code: 2,
    name: "GOOD_ANSWER",
    desc: "优选",
    kind: "filterWay"
  },
  FULL_SCORE: {
    code: 3,
    name: "FULL_SCORE",
    desc: "满分",
    kind: "filterWay"
  },
}

export default Object.freeze(filterWayEnum)